export default {"src":"/_next/static/media/fiveStars.ea4b1a2e.svg","height":12,"width":81,"blurWidth":0,"blurHeight":0};